import { gsap, ScrollTrigger } from "../layout";

// swiper
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Thumbs, EffectFade } from 'swiper/modules';

// matchheight
import {matchHeight} from '../matchHeight';

function factSection() {
    var factSwiper = new Swiper(".fact__swiper", {
        modules: [ Pagination, Navigation, Autoplay, EffectFade ],
        effect: "fade",
        pagination: {
            el: ".fact__pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".fact__next",
            prevEl: ".fact__prev",
        },
    });
}

function otherSection() {
    if (window.innerWidth < 992) {
        let cols = document.querySelectorAll(".info-others__col .col-6");
        if (cols.length % 2 !== 0) {
          cols[cols.length - 1].classList.remove("col-6");
          cols[cols.length - 1].classList.add("col-12");
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    factSection();
    otherSection();
})

window.addEventListener('resize', () => {
    
})